import { useStyles } from '@archipro-design/aria';
import type { TextTypeEnum } from 'generated/graphql';
import { RichTextEditorNodeStyling } from '../RichTextStyling.style';

interface RichTextDisplayProps {
    textType: TextTypeEnum;
    contentHTML?: string;
}

const RichTextDisplay = ({ textType, contentHTML }: RichTextDisplayProps) => {
    const { css } = useStyles({ textType });
    const createMarkup = (html?: string) => ({ __html: html || '' });
    return (
        <div
            className={css(RichTextEditorNodeStyling)}
            dangerouslySetInnerHTML={createMarkup(contentHTML)}
        />
    );
};

export default RichTextDisplay;
